import Api from './BaseRequest';

const Get = (id) => {
    if (id) {
        return Api.Get('/api/conversation/' + id);
    }
    return Api.Get('/api/conversations');
};

const Post = (conversationId, messageId, message) => {
    return Api.Post('/api/message', {
        conversationId: conversationId,
        afterMessageId: messageId,
        message: message,
    });
};

const Refresh = (conversationId, messageId) => {
    return Api.Get('/api/conversation/' + conversationId + '?afterMessageId=' + messageId);
};

export default {
    Get,
    Post,
    Refresh,
};
